import React from 'react';
import { Box } from '@mui/material';

const CourseProfitability: React.FC = () => {
  return (
    <Box sx={{ height: 'calc(100vh - 64px)', bgcolor: '#0a0f1a' }}>
      <iframe
        title="Course Profitability"
        src="/course-profitability/index.html"
        style={{
          width: '100%',
          height: '100%',
          border: 0,
          display: 'block',
          background: '#0a0f1a',
        }}
      />
    </Box>
  );
};

export default CourseProfitability;
